import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		paper: {
			padding: theme.spacing(2.5),
			borderRadius: 0,
			height: '100%',
			[theme.breakpoints.up('sm')]: {
				padding: theme.spacing(4.5),
			},
		},
		image: {
			marginBottom: theme.spacing(3.1),
			padding: theme.spacing(2, 2, 0, 2),

			'& img': {
				width: '100%',
			},

			[theme.breakpoints.up('sm')]: {
				padding: 0,
			},
		},
		text: {
			marginBottom: theme.spacing(3.7),
		},
	}),
	{ name: 'CallToAction-Cta9' },
)

export default useStyles
